function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 1000,
  cy: 1000,
  r: 960.952,
  fill: "white",
  stroke: "white",
  strokeWidth: 78.0966
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_1076:538)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1384.23 1000.31C1384.23 1213.2 1211.93 1385.61 999.611 1385.61C787.288 1385.61 614.996 1213.2 614.996 1000.31C614.996 787.412 787.288 614.996 999.611 614.996C1211.93 614.996 1384.23 787.412 1384.23 1000.31Z",
  fill: "black",
  stroke: "black",
  strokeWidth: 127.993
}), /*#__PURE__*/React.createElement("path", {
  d: "M1126.19 923.482C1139.09 920.391 1153.21 918.738 1167.65 918.738C1182.09 918.738 1196.21 920.391 1209.11 923.483C1222.05 926.585 1233 930.951 1241.53 935.892C1251.94 941.914 1266.05 944.115 1275.85 937.164L1287.44 928.949C1303.64 917.461 1307.41 894.669 1291.44 882.866C1287.08 879.642 1282.49 876.657 1277.74 873.907C1262.29 864.96 1244.64 858.248 1225.98 853.774C1207.27 849.29 1187.48 847.035 1167.65 847.035C1147.82 847.035 1128.03 849.29 1109.32 853.774C1090.66 858.248 1073.01 864.96 1057.55 873.907C1042.16 882.817 1028.5 894.206 1018.53 908.148C1014.09 914.349 1012.61 920.697 1012.3 922.033L1012.26 922.172C1011.68 924.602 1011.33 926.913 1011.1 928.663C1010.63 932.258 1010.31 936.399 1010.07 940.556C1009.59 949.024 1009.31 960.125 1009.16 972.629C1008.85 997.768 1009.06 1030.3 1009.46 1062.58C1009.86 1094.91 1010.46 1127.24 1010.96 1152.04C1011.16 1162.09 1011.34 1170.92 1011.49 1178L1011.59 1182.69C1011.67 1186.55 1011.74 1189.68 1011.78 1191.99L1011.81 1193.54L1011.82 1194.11L1011.83 1194.76C1011.83 1194.97 1011.84 1195.14 1011.84 1195.27L1011.84 1195.52L1011.84 1195.74L1011.85 1195.76L1011.85 1195.77L1011.87 1195.77H1064.44C1075.18 1195.77 1083.73 1187.11 1083.51 1176.42L1083.51 1176.39C1082.98 1151.27 1082.03 1105.76 1081.49 1061.7C1081.09 1029.56 1080.9 997.733 1081.19 973.493C1081.25 968.158 1081.34 963.263 1081.45 958.873C1081.69 949.572 1085.69 940.569 1093.77 935.892C1102.3 930.951 1113.25 926.585 1126.19 923.482Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M784.929 932.547C797.196 929.64 810.683 928.072 824.522 928.072C838.361 928.072 851.849 929.64 864.115 932.547C881.634 936.7 901.78 931.416 910.755 915.876L912.455 912.933C922.369 895.767 916.394 873.612 897.486 867.464C892.055 865.698 886.483 864.142 880.803 862.795C862.788 858.525 843.684 856.37 824.522 856.37C805.36 856.37 786.256 858.525 768.242 862.795C750.259 867.058 733.355 873.43 718.638 881.852C714.848 884.02 711.184 886.337 707.674 888.8C691.416 900.209 695.01 923.017 711.149 934.592L725.421 944.827C733.679 950.749 745.718 949.063 754.541 944.014C762.361 939.539 772.606 935.468 784.929 932.547Z",
  fill: "white"
}));

function SvgXtarotFace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2000,
    height: 2000,
    viewBox: "0 0 2000 2000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1076:538",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 2000,
    height: 2000
  }, _ref2), _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXtarotFace);
export default __webpack_public_path__ + "static/media/xtarot-face.a193a660.svg";
export { ForwardRef as ReactComponent };